import React, { useEffect } from 'react'
import "./style.scss"
import { Link, useLocation } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import { useDispatch } from 'react-redux';
import { getPlanPatmentStatus } from '../../core/data/redux/pricing/_pricingAction';


const PaymentSuccess = () => {
  const dispatch: any = useDispatch();
  const location = useLocation();

  const routes: any = all_routes;
  const queryParams = new URLSearchParams(location.search);

  // Extract session_id from query parameters
  const sessionId = queryParams.get('session_id');

  useEffect(() => {
    getPaymentDetails();
  }, [dispatch]);

  const getPaymentDetails = async () => {
    try {
      const response = await dispatch(getPlanPatmentStatus({ session_id: sessionId }));
    } catch (error) {
      console.error('Error fetching payment details:', error);
    }
  }


  return (
    <div className="payment-succesful-page">
      <div className="content">
        <div className="container d-flex align-items-center justify-content-center">
          <div className="payment-succesful-inner d-flex align-items-center justify-content-center">
            <div className="payment-succesful-inner-2 text-center d-flex align-items-center flex-column gap-2">
              <img
                className="img-fluid"
                src="/assets/img/check-image.png"
                alt="Logo"
              />
              <h2 className='mt-4'>Payment Successful!</h2>
              <p className="text-center thank mb-2">Thank you your transaction is complete, and your services are now active.</p>
              {/* <p className="text-center transaction">Transaction ID: {sessionId}</p> */}
              <Link className='primaryButton' to={routes.dashboard}>Go To Dashboard</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;